import {ContactRequest} from 'shared/models/contactForm';

import {ApiAxios} from './axiosClient';

const CONTACT_PATH = '/contactus';

class ContactService {
  private static instance: ContactService | null = null;

  public static getInstance(): ContactService {
    if (!ContactService.instance) {
      ContactService.instance = new ContactService();
    }
    return ContactService.instance;
  }

  public async sendContactRequest(contactRequest: ContactRequest): Promise<any> {
    try {
      const response = await ApiAxios.post(CONTACT_PATH, contactRequest);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export const contactService = ContactService.getInstance();
